import { useEffect } from 'react';
import { useToasts } from '@blaze-react/toaster';

const CartMessagesComponent = ({ cartData }) => {
  const { addToast } = useToasts();
  const { messages } = cartData || {};

  useEffect(
    () => {
      if (!messages) return;

      Object.entries(messages).forEach(([type, messageSection]) => {
        const appearance = type === 'info' ? 'success' : type;
        if (!Array.isArray(messageSection)) return;
        messageSection.forEach(({ label, value }) => {
          let message = value;
          if (label) message = `${label}: ${value}`;

          addToast(message, {
            appearance,
            autoDismiss: true
          });
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addToast, messages]
  );

  return null;
};

export default CartMessagesComponent;
